import { redactAuthLogValue } from "./auth-log-redaction.js";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function readAuthErrorMessage(value: unknown): string | null {
  if (value instanceof Error) return value.message;
  if (typeof value === "string") return value;
  if (!isRecord(value)) return null;

  if (typeof value.message === "string") return value.message;
  if (typeof value.error === "string") return value.error;
  return null;
}

export function getPublicAuthErrorMessage(value: unknown, fallback = "Internal Server Error"): string {
  const rawMessage = readAuthErrorMessage(value)?.trim();
  if (!rawMessage) return fallback;

  const redacted = redactAuthLogValue(rawMessage);
  if (redacted !== rawMessage || redacted.includes("<redacted>")) {
    return fallback;
  }

  return redacted;
}

export function sanitizePublicAuthResponsePayload(
  payload: unknown,
  fallback = "Authentication failed",
): Record<string, unknown> {
  if (!isRecord(payload)) return { error: fallback };

  const sanitized: Record<string, unknown> = {};
  if (typeof payload.error === "string") {
    sanitized.error = getPublicAuthErrorMessage(payload.error, fallback);
  }
  if (typeof payload.message === "string") {
    sanitized.message = getPublicAuthErrorMessage(payload.message, fallback);
  }
  if (!("error" in sanitized) && !("message" in sanitized)) {
    sanitized.error = fallback;
  }

  return sanitized;
}
